import React from 'react'
import { LodgingAmenitiesSection } from 'components/DataExpansionComponents/GooglePlaces/Lodging/LodgingAmenitiesSection'
import { LodgingChainProxy } from 'models/google_place_chain'
import {
  buildGooglePlaceSummaryContent,
  buildGooglePlaceLocationContent,
  GOOGLE_PLACE_CONFIGS,
} from '../utils/googlePlacesHelpers'
import { BuildCompanyTypeContentOptions, CompanyTypePageContent } from './types'

interface BuildLodgingOptions extends BuildCompanyTypeContentOptions {
  /** Gate the hotel amenities section behind its feature flag (read by caller). */
  includeAmenities?: boolean
}

/**
 * Shared lodging content derivation used by both `NewLodgingPage` (desktop) and
 * `MobileLodgingPage`. Reuses the Google-Places content helpers.
 * See {@link CompanyTypePageContent}.
 */
export function buildLodgingPageContent(
  data: LodgingChainProxy | undefined,
  { onViewDoors, includeAmenities = false }: BuildLodgingOptions = {}
): CompanyTypePageContent {
  const lodging = data?.lodging
  const config = GOOGLE_PLACE_CONFIGS.lodging

  const summaryContent: React.ReactNode[] = [
    ...buildGooglePlaceSummaryContent({
      placeData: lodging,
      onViewDoorsClick: onViewDoors ?? (() => {}),
      hideDoorsMetric: !onViewDoors,
    }),
    ...(includeAmenities
      ? [<LodgingAmenitiesSection key="amenities" data={lodging} />]
      : []),
  ]

  const locationDetailsContent = buildGooglePlaceLocationContent(lodging)

  return {
    documentTitle: `${lodging?.name || 'Not Found'} (Lodging) - First Bite`,
    header: {
      name: lodging?.name ?? '',
      domain: lodging?.domain ?? undefined,
      logoUrl: undefined,
    },
    contactCompanyId: data?.id,
    doorsCount: lodging?.doors_cnt ?? 0,
    summaryContent,
    locationDetailsContent,
    breadcrumbRoot: config.breadcrumbRoot,
    breadcrumbTitle: config.breadcrumbTitle,
    categoryInfo: {
      categorySlug: 'commercial',
      subCategorySlug: 'lodging-hospitality',
    },
    companyTypeSlug: 'lodging-hospitality',
    tableTypeSlug: 'lodging-hospitality',
    modalSubCategory: {
      name: config.modalName,
      // config.modalSlug is typed loosely as string; this literal is the same value.
      slug: 'lodging-hospitality',
      description: config.modalName,
    },
  }
}
